// src/components/portal/AppPortal.js
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const PortalContainer = styled.div`
    min-height: 100vh;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
`;

const ContentWrapper = styled.div`
    max-width: 1200px;
    width: 100%;
    text-align: center;
`;

const Title = styled.h1`
    font-size: 3.5rem;
    color: white;
    margin-bottom: 1rem;
    font-weight: 700;
    
    @media (max-width: 768px) {
        font-size: 2.5rem;
    }
`;

const Subtitle = styled.p`
    font-size: 1.25rem;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 4rem;
`;

const AppsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 2rem;
    
    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }
`;

const AppCard = styled(Link)`
    background: white;
    border-radius: 20px;
    padding: 3rem;
    text-decoration: none;
    color: inherit;
    transition: all 0.3s ease;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;
    
    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
    }
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 5px;
        background: ${props => props.color};
    }
`;

const AppIcon = styled.div`
    width: 80px;
    height: 80px;
    margin: 0 auto 1.5rem;
    background: ${props => props.color};
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.5rem;
`;

const AppTitle = styled.h2`
    font-size: 1.75rem;
    margin-bottom: 1rem;
    color: #333;
`;

const AppDescription = styled.p`
    font-size: 1.1rem;
    color: #666;
    line-height: 1.6;
`;

const AppPortal = () => {
    return (
        <PortalContainer>
            <ContentWrapper>
                <Title>Mind World</Title>
                <Subtitle>당신의 마음을 위한 특별한 여정을 선택하세요</Subtitle>

                <AppsGrid>
                    <AppCard to="/wellness" color="#4CAF50">
                        <AppIcon color="#4CAF50">🧘</AppIcon>
                        <AppTitle>Mind Wellness</AppTitle>
                        <AppDescription>
                            마음의 평화와 안정을 찾아가는 여정<br/>
                            스트레스 해소와 정서적 웰빙을 위한 솔루션
                        </AppDescription>
                    </AppCard>

                    <AppCard to="/workout" color="#FF6B6B">
                        <AppIcon color="#FF6B6B">💪</AppIcon>
                        <AppTitle>Mind Workout</AppTitle>
                        <AppDescription>
                            정신력을 단련하는 체계적인 훈련<br/>
                            게임처럼 재미있게 마음의 근육을 키우세요
                        </AppDescription>
                    </AppCard>

                    <AppCard to="/mindattention" color="#7C3AED">
                        <AppIcon color="#7C3AED">🎯</AppIcon>
                        <AppTitle>Mind Attention</AppTitle>
                        <AppDescription>
                            ADHD 증상 관리와 집중력 향상<br/>
                            과학적 CBT 기반의 맞춤형 집중력 훈련
                        </AppDescription>
                    </AppCard>

                    <AppCard to="/growbeyondtoday" color="#9BB167">
                        <AppIcon color="#9BB167">🌿</AppIcon>
                        <AppTitle>오늘보다</AppTitle>
                        <AppDescription>
                            행동 기반 가족 성장 체감 앱<br/>
                            0~7세 자녀의 변화를 기록하고 데이터로 확인하세요
                        </AppDescription>
                    </AppCard>

                    <AppCard to="/healthcheck" color="#0D9488">
                        <AppIcon color="#0D9488">🏥</AppIcon>
                        <AppTitle>헬스체크</AppTitle>
                        <AppDescription>
                            건강검진 결과 AI 분석 앱<br/>
                            복잡한 검진 결과를 쉬운 말로 이해하세요
                        </AppDescription>
                    </AppCard>

                    <AppCard to="/ingredientchecker" color="#EA580C">
                        <AppIcon color="#EA580C">🧪</AppIcon>
                        <AppTitle>성분체크</AppTitle>
                        <AppDescription>
                            AI 성분 분석 앱<br/>
                            식품·화장품 성분을 촬영하면 유해 성분을 알려드려요
                        </AppDescription>
                    </AppCard>

                    <AppCard to="/arrowquest" color="#2E86EE">
                        <AppIcon color="#2E86EE">🏹</AppIcon>
                        <AppTitle>Arrow Quest</AppTitle>
                        <AppDescription>
                            화살표 퍼즐 캐주얼 게임<br/>
                            화살표를 뒤집어 그리드를 클리어하는 두뇌 퍼즐
                        </AppDescription>
                    </AppCard>

                    <AppCard to="/cubiepop" color="#7C4DFF">
                        <AppIcon color="#7C4DFF">🧩</AppIcon>
                        <AppTitle>CubiePop</AppTitle>
                        <AppDescription>
                            큐브 팡(블래스트) 퍼즐 게임<br/>
                            같은 색 큐브 그룹을 탭해 터뜨리는 캐주얼 퍼즐
                        </AppDescription>
                    </AppCard>

                    <AppCard to="/cryptcrawler" color="#9B2C2C">
                        <AppIcon color="#9B2C2C">🗝️</AppIcon>
                        <AppTitle>CryptCrawler</AppTitle>
                        <AppDescription>
                            로그라이크 덱빌딩 던전 게임<br/>
                            카드로 덱을 짜며 지하 묘지를 내려가는 카드 배틀
                        </AppDescription>
                    </AppCard>
                </AppsGrid>
            </ContentWrapper>
        </PortalContainer>
    );
};

export default AppPortal;
